import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HiOutlineStar, HiOutlineCollection } from 'react-icons/hi';
import StickerCard from '../components/StickerCard';

function Favorites() {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    fetchFavorites();
  }, []);
  
  const fetchFavorites = async () => {
    try {
      const response = await fetch('http://localhost/sticker-library/api/index.php/favorites');
      const data = await response.json();
      
      if (data.data) {
        setFavorites(data.data);
      }
    } catch (error) {
      console.error('Erro ao buscar favoritos:', error);
      // Dados mockados para demonstração
      setFavorites([
        { 
          id: 1, 
          sticker_id: 1,
          sticker_name: 'Bom Dia Tiriás', 
          sticker_slug: 'bom-dia-tirias', 
          image_path: '',
          category_name: 'Bom Dia',
          category_emoji: '☀️'
        },
        { 
          id: 2, 
          sticker_id: 3,
          sticker_name: 'Good Morning', 
          sticker_slug: 'good-morning', 
          image_path: '',
          category_name: 'Bom Dia',
          category_emoji: '☀️'
        },
        { 
          id: 3, 
          sticker_id: 10,
          sticker_name: 'Frases Motivacionais', 
          sticker_slug: 'frases-motivacionais', 
          image_path: '',
          category_name: 'Frases',
          category_emoji: '✍️'
        }
      ]);
    } finally {
      setLoading(false);
    }
  };
  
  const handleRemoveFavorite = async (favoriteId) => {
    try {
      await fetch(`http://localhost/sticker-library/api/index.php/favorites/${favoriteId}`, {
        method: 'DELETE',
      });
      
      setFavorites(favorites.filter(fav => fav.id !== favoriteId));
    } catch (error) {
      console.error('Erro ao remover favorito:', error);
      // Remover localmente para demonstração
      setFavorites(favorites.filter(fav => fav.id !== favoriteId));
    }
  };
  
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }
  
  return (
    <div className="favorites-page">
      {/* Header */}
      <div className="page-header">
        <h1 className="page-title">
          <HiOutlineStar style={{ marginRight: '12px', verticalAlign: 'middle' }} />
          Meus Favoritos
        </h1>
        <p className="page-subtitle">
          Seus stickers favoritos salvos para acesso rápido.
        </p>
      </div>
      
      {/* Stats */}
      <div className="stats-section">
        <div className="stat-card">
          <div className="stat-value">{favorites.length}</div>
          <div className="stat-label">Favoritos</div>
        </div>
      </div>
      
      {/* Favorites Grid */}
      {favorites.length > 0 ? (
        <div className="stickers-grid">
          {favorites.map((favorite) => (
            <StickerCard 
              key={favorite.id}
              sticker={{
                id: favorite.sticker_id,
                name: favorite.sticker_name,
                slug: favorite.sticker_slug,
                image_path: favorite.image_path,
                is_favorite: true
              }}
              onFavoriteToggle={(stickerId, isFavorite) => {
                if (!isFavorite) {
                  handleRemoveFavorite(favorite.id);
                }
              }}
            />
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <div className="empty-state-icon">
            <HiOutlineStar />
          </div>
          <h3 className="empty-state-title">Nenhum favorito ainda</h3>
          <p className="empty-state-text">
            Explore nossa biblioteca e salve seus stickers favoritos clicando no ícone de coração.
          </p>
          <Link to="/" className="btn btn-primary" style={{ marginTop: '16px' }}>
            <HiOutlineCollection />
            Explorar Biblioteca
          </Link>
        </div>
      )}
    </div>
  );
}

export default Favorites;
